module.exports = __webpack_public_path__ + "static/img/logo-bai.2c549a33.png";